import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Lm9jaXF1bTAgewogIG92ZXJmbG93LXg6IGF1dG87CiAgc2Nyb2xsYmFyLXdpZHRoOiBub25lOwp9';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Lm9jaXF1bTA6Oi13ZWJraXQtc2Nyb2xsYmFyIHsKICBkaXNwbGF5OiBub25lOwp9';
export var swipableBoxStyle = 'ociqum0';